import { http } from 'vue'

export default {
  // edit company_client at the API server
  putCompanyClient (context, params = {}) {
    return http.put('company_clients/' + params.id, params.data)
  },
  deleteCompanyClient (context, params = {}) {
    return http.delete('company_clients/' + params.id)
  },
  // Updates notifications on other users' screens via broadcasting
  sendEventForUpdateUi (context, params = {}) {
    return http.get('company_clients/update_ui_event/' + params.companyId + '/ ' + params.clientId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_clients/actions.js